import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-800 text-white pt-8 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/USSdogsLogo.png"
                alt="US Service Dogs Logo"
                className="h-10 w-auto"
              />
              <h3 className="font-bold text-lg">US Service Dog Registry</h3>
            </div>
            <p className="text-sm text-primary-200 mb-4">
              The official national registry for service dogs, providing verification and registration services for service animal owners across the United States.
            </p>
            <div className="flex space-x-4 mt-4">
              <img
                src="/dojLogo.png"
                alt="Department of Justice Logo"
                className="h-10 w-auto"
              />
                 <img
                src="/ACLU.png"
                alt="ACLU Logo"
                className="h-10 w-auto"
              />
              <img
                src="/ada_v2.png"
                alt="ADA Logo"
                className="h-10 w-auto"
              />

            </div>
          </div>

          <div>
            <h4 className="font-semibold text-primary-100 mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-primary-200 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-primary-200 hover:text-white transition-colors">
                  Register a Service Dog
                </Link>
              </li>
              <li>
                <Link to="/lookup" className="text-primary-200 hover:text-white transition-colors">
                  Verify a Registration
                </Link>
              </li>
              <li>
                <Link to="/admin/login" className="text-primary-200 hover:text-white transition-colors">
                  Admin Portal
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-primary-100 mb-4">Government Resources</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://www.ada.gov/topics/service-animals/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-primary-200 hover:text-white transition-colors"
                >
                  <span>ADA Service Animal Guidelines</span>
                  <ExternalLink size={12} className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.justice.gov/crt/disability-rights-section"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-primary-200 hover:text-white transition-colors"
                >
                  <span>DOJ Disability Rights</span>
                  <ExternalLink size={12} className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.transportation.gov/individuals/aviation-consumer-protection/service-animals"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-primary-200 hover:text-white transition-colors"
                >
                  <span>Air Carrier Access Act</span>
                  <ExternalLink size={12} className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.hud.gov/program_offices/fair_housing_equal_opp/fair_housing_act_overview"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-primary-200 hover:text-white transition-colors"
                >
                  <span>Fair Housing Act</span>
                  <ExternalLink size={12} className="ml-1" />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-primary-100 mb-4">Contact Information</h4>
            <address className="text-sm text-primary-200 not-italic">
              <p>Email: USServiceDogs.US@outlook.com</p>
              <p>Phone: (202) 514-3847</p>
              <p>Hours: Monday - Friday, 9am - 5pm EST</p>
            </address>
            <div className="mt-4">
              <p className="text-sm text-primary-200">ADA Information Line:</p>
              <p className="text-sm text-primary-200">800-514-0301 (Voice)</p>
              <p className="text-sm text-primary-200">800-514-0383 (TTY)</p>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-700 mt-6 pt-6 text-center text-xs text-primary-300">
          <p>&copy; {currentYear} US Service Dog Registry. All rights reserved.</p>
          <p className="mt-2">
            This registry provides official documentation in accordance with the Americans with Disabilities Act (ADA),
            the Fair Housing Act (FHA), and the Air Carrier Access Act (ACAA). Registration does not confer additional rights
            beyond those provided by federal law.
          </p>
          <p className="mt-2">
            For questions about service animal laws and regulations, please contact the Department of Justice ADA Information Line
            at 800-514-0301 (Voice) or 800-514-0383 (TTY).
          </p>
          <div className="flex justify-center space-x-4 mt-4">
            <a
              href="https://www.ada.gov"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-300 hover:text-white transition-colors"
            >
              ADA.gov
            </a>
            <a
              href="https://www.justice.gov"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-300 hover:text-white transition-colors"
            >
              Justice.gov
            </a>
            <a
              href="https://www.transportation.gov"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-300 hover:text-white transition-colors"
            >
              Transportation.gov
            </a>
            <a
              href="https://www.hud.gov"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-300 hover:text-white transition-colors"
            >
              HUD.gov
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;